
import _ from 'lodash';

export default {
  name: 'AppMultiTabDropdownMenu',
  props: {
    options: { type: Array, required: true },
    selectedOptions: { type: Object, default: null },
    description: { type: String, default: null },
    maxHeight: { type: Number, default: null }
  },
  data() {
    return {
      selectedTabIndex: 0,
      currentValue: Object.fromEntries(this.options.map(item => [item.id, []])),
      isScrollingByClick: false,
      headerHeight: 0,
      footerHeight: 0
    };
  },
  computed: {
    tabNames() {
      return this.options.map(option => option.name);
    },
    listStyle() {
      const total = this.maxHeight || 480;
      const maxHeight = Math.max(
        total - this.headerHeight - this.footerHeight,
        0
      );
      return { 'max-height': `${maxHeight}px` };
    }
  },
  mounted() {
    this.headerHeight = this.$refs.header?.offsetHeight ?? 0;
    this.footerHeight = this.$refs.footer?.offsetHeight ?? 0;
  },
  created() {
    if (!this.selectedOptions) return;

    Object.entries(this.selectedOptions).forEach(([optionId, optionValues]) => {
      this.$set(this.currentValue, optionId, optionValues);
    });
  },
  methods: {
    scrollToTab(idx) {
      this.selectedTabIndex = idx;
      const item = this.$refs[`item-${idx}`]?.[0];
      const list = this.$refs.list;
      if (!item || !list) return;

      this.isScrollingByClick = true;
      list.scrollTo({
        top: item.offsetTop - list.offsetTop,
        behavior: 'smooth'
      });
      setTimeout(() => {
        this.isScrollingByClick = false;
      }, 300);
    },
    onScroll() {
      if (this.isScrollingByClick) return;

      const list = this.$refs.list;
      if (!list) return;
      const listTop = list.getBoundingClientRect().top;
      const threshold = 50;

      for (let i = this.options.length - 1; i >= 0; i--) {
        const item = this.$refs[`item-${i}`]?.[0];
        if (!item) continue;
        if (item.getBoundingClientRect().top - listTop < threshold) {
          this.selectedTabIndex = i;
          return;
        }
      }
      this.selectedTabIndex = 0;
    },
    apply() {
      if (!_.isEqual(this.selectedOptions || {}, this.currentValue)) {
        this.$emit('change', this.currentValue);
      }
      this.$emit('close');
    },
    clickResetButton() {
      Object.keys(this.currentValue).forEach(optionId => {
        this.$set(this.currentValue, optionId, []);
      });
    },
    isSelected(optionId, value) {
      return this.currentValue[optionId]?.includes(value) || false;
    },
    clickOption(option, value) {
      if (option.disabled) return;

      const oldOptionValue = this.currentValue[option.id] || [];
      if (oldOptionValue.includes(value)) {
        this.currentValue[option.id] = oldOptionValue.filter(
          oldValue => oldValue !== value
        );
      } else {
        this.currentValue[option.id] = [...oldOptionValue, value];
      }
    }
  }
};
